module.exports = __webpack_public_path__ + "static/media/testimonial-karimatul.ce199471.png";